import PropTypes from 'prop-types'

export const pageContentType = PropTypes.shape({
  blocks: PropTypes.arrayOf(PropTypes.shape()),
})

export const pageContentDefaultProps = {}
